import React from 'react';
import { CheckCircleIcon, CalendarIcon, MessageSquareIcon, HandshakeIcon } from 'lucide-react';
export function SolutionBreakdown() {
  return <section className="w-full bg-gray-50 py-16 md:py-24" data-id="element-233">
      <div className="max-w-4xl mx-auto px-4" data-id="element-234">
        {/* Introduction */}
        <div className="text-center mb-16" data-id="element-235">
          <h2 className="font-heading text-3xl md:text-5xl text-blueprint-blue mb-6" data-id="element-236">
            He creado <span className="text-safety-yellow" data-id="element-237">Blindaje 21</span>{' '}
            para el contratista que no tiene tiempo de leer libros de 300
            páginas.
          </h2>
          <p className="text-xl md:text-2xl text-industrial-gray leading-relaxed" data-id="element-238">
            Este es un manual de{' '}
            <span className="font-semibold" data-id="element-239">"botas en el terreno"</span>.
          </p>
        </div>

        {/* 21-Day Plan */}
        <div className="mb-12" data-id="element-240">
          <h3 className="font-heading text-2xl md:text-4xl text-blueprint-blue mb-8 text-center" data-id="element-241">
            En solo 21 días, te enseñaré a:
          </h3>

          <div className="space-y-8" data-id="element-242">
            {/* Days 1-7 */}
            <div className="bg-white p-8 rounded-lg shadow-lg border-t-4 border-safety-yellow" data-id="element-243">
              <div className="flex items-start gap-4 mb-4" data-id="element-244">
                <div className="bg-safety-yellow text-dark-gray font-heading text-3xl px-4 py-2 rounded-lg flex-shrink-0" data-id="element-245">
                  1-7
                </div>
                <div data-id="element-246">
                  <h4 className="font-heading text-2xl md:text-3xl text-blueprint-blue mb-2" data-id="element-247">
                    Días 1-7: Dinero Inmediato
                  </h4>
                  <p className="text-lg md:text-xl text-industrial-gray leading-relaxed" data-id="element-248">
                    Sacar dinero de donde no sabías que tenías.{' '}
                    <span className="font-semibold text-blueprint-blue" data-id="element-249">
                      Reactivación de prospectos
                    </span>{' '}
                    que ya te conocen pero nunca cerraste.
                  </p>
                </div>
              </div>
              <ul className="space-y-3 ml-20" data-id="element-250">
                <li className="flex items-start gap-3" data-id="element-251">
                  <CheckCircleIcon className="w-6 h-6 text-safety-yellow flex-shrink-0 mt-1" aria-hidden="true" data-id="element-252" />
                  <span className="text-industrial-gray" data-id="element-253">
                    El guion de WhatsApp que reactiva clientes muertos en 10
                    minutos
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-254">
                  <CheckCircleIcon className="w-6 h-6 text-safety-yellow flex-shrink-0 mt-1" aria-hidden="true" data-id="element-255" />
                  <span className="text-industrial-gray" data-id="element-256">
                    Cómo convertir presupuestos viejos en contratos nuevos
                  </span>
                </li>
              </ul>
            </div>

            {/* Days 8-14 */}
            <div className="bg-white p-8 rounded-lg shadow-lg border-t-4 border-construction-orange" data-id="element-257">
              <div className="flex items-start gap-4 mb-4" data-id="element-258">
                <div className="bg-construction-orange text-white font-heading text-3xl px-4 py-2 rounded-lg flex-shrink-0" data-id="element-259">
                  8-14
                </div>
                <div data-id="element-260">
                  <h4 className="font-heading text-2xl md:text-3xl text-blueprint-blue mb-2" data-id="element-261">
                    Días 8-14: Tu Propia Máquina de Leads
                  </h4>
                  <p className="text-lg md:text-xl text-industrial-gray leading-relaxed" data-id="element-262">
                    Crear tu propia{' '}
                    <span className="font-semibold text-blueprint-blue" data-id="element-263">
                      "Micro-Licitación"
                    </span>
                    . Atrae dueños de casa directamente a tu WhatsApp por menos
                    de lo que cuesta un almuerzo.
                  </p>
                </div>
              </div>
              <ul className="space-y-3 ml-20" data-id="element-264">
                <li className="flex items-start gap-3" data-id="element-265">
                  <CheckCircleIcon className="w-6 h-6 text-construction-orange flex-shrink-0 mt-1" aria-hidden="true" data-id="element-266" />
                  <span className="text-industrial-gray" data-id="element-267">
                    Cómo capturar dueños ANTES de que vayan a plataformas
                    grandes
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-268">
                  <CheckCircleIcon className="w-6 h-6 text-construction-orange flex-shrink-0 mt-1" aria-hidden="true" data-id="element-269" />
                  <span className="text-industrial-gray" data-id="element-270">
                    Dominio local: Ser el único contratista en tu código postal
                  </span>
                </li>
              </ul>
            </div>

            {/* Days 15-21 */}
            <div className="bg-white p-8 rounded-lg shadow-lg border-t-4 border-blueprint-blue" data-id="element-271">
              <div className="flex items-start gap-4 mb-4" data-id="element-272">
                <div className="bg-blueprint-blue text-white font-heading text-3xl px-4 py-2 rounded-lg flex-shrink-0" data-id="element-273">
                  15-21
                </div>
                <div data-id="element-274">
                  <h4 className="font-heading text-2xl md:text-3xl text-blueprint-blue mb-2" data-id="element-275">
                    Días 15-21: El Arte del Cierre Veloz
                  </h4>
                  <p className="text-lg md:text-xl text-industrial-gray leading-relaxed" data-id="element-276">
                    Deja de enviar presupuestos por email para que los ignoren.{' '}
                    <span className="font-semibold text-blueprint-blue" data-id="element-277">
                      Ciérralos en su sala
                    </span>
                    .
                  </p>
                </div>
              </div>
              <ul className="space-y-3 ml-20" data-id="element-278">
                <li className="flex items-start gap-3" data-id="element-279">
                  <CheckCircleIcon className="w-6 h-6 text-blueprint-blue flex-shrink-0 mt-1" aria-hidden="true" data-id="element-280" />
                  <span className="text-industrial-gray" data-id="element-281">
                    La estrategia de "Diagnóstico de Valor" que cierra en la
                    primera visita
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-282">
                  <CheckCircleIcon className="w-6 h-6 text-blueprint-blue flex-shrink-0 mt-1" aria-hidden="true" data-id="element-283" />
                  <span className="text-industrial-gray" data-id="element-284">
                    Cómo eliminar el "Te aviso luego" para siempre
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Closing Statement */}
        <div className="text-center bg-blueprint-blue text-white p-8 md:p-12 rounded-lg" data-id="element-285">
          <p className="text-2xl md:text-3xl font-heading mb-4" data-id="element-286">
            Este mes no tiene por qué ser un desastre.
          </p>
          <p className="text-xl md:text-2xl" data-id="element-287">
            No necesitas ser un experto en marketing.{' '}
            <span className="text-safety-yellow font-bold" data-id="element-288">
              Necesitas un plan de batalla.
            </span>
          </p>
        </div>
      </div>
    </section>;
}